import { inject, Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { EMPTY, Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Helper, parseApiResponseObject2 } from "@helpers/functions";
import { UserService } from "@main-services/user.service";
import { UserJourney } from "@modules/shared/terms-and-conditions/entities/terms-and-conditions.model";

export interface userStatus {
	enabled: boolean;
	user_journey?: UserJourney;
}

@Injectable({
	providedIn: "root"
})
export class AdvTradingRemote {
	private readonly apicallService = inject(ApicallService);
	private readonly userService = inject(UserService);

	public checkIfUserIsProvisioned$(): Observable<userStatus> {
		const option = new ApicallOption();
		option.apiVersion = "v1";
		option.raw = true;
		return this.apicallService
			.get("advanced-trading/users/status", option)
			.pipe(map((res) => parseApiResponseObject2(res)));
	}

	public provideUserToTalos$(): Observable<void> {
		const option = new ApicallOption(null, {
			userId: this.userService.user.getId()
		});
		return this.apicallService.post("advanced-trading/users/provision", option).pipe(
			catchError((e) => {
				Helper.handleError(e);
				return EMPTY;
			})
		);
	}
}
